import React, { Component } from 'react'

class Banner extends Component {
  render() {
    return (
      <div className="inner-banner">
        <div className="opacity">
          <div className="container">
            <h2>Privacy & Policy</h2>
            <ul>
              <li><a href="/" className="tran3s">Home</a></li>
              <li>/</li>
              <li>Privacy & Policy</li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}



export default Banner